module.exports = __webpack_public_path__ + "img/hero-illustration.818702ad.svg";